export enum InsuranceCoverage {
    HEALTH_INSURANCE = 'HEALTH_INSURANCE',
    LIFE_INSURANCE = 'LIFE_INSURANCE',
    LONG_TERM_DISABILITY = 'LONG_TERM_DISABILITY',
    SHORT_TERM_DISABILITY = 'SHORT_TERM_DISABILITY',
    WILL = 'WILL',
    MEDICAL_DIRECTIVE = 'MEDICAL_DIRECTIVE',
    NONE = 'NONE',
}
